import localStorageUtil from '@/utils/localStorageUtil'
import { secondsToMinAndSec } from '@/utils/numberUtils'

export default {

  state: {
    currentBox: localStorageUtil.getCurrentBox(),
    audioPlaying: false,
    boxStatus: null,
    allBoxes: localStorageUtil.getAllBoxes()
  },

  mutations: {

    setAllBoxes (state, allBoxes) {
      state.allBoxes = allBoxes
    },

    setAudioPlaying (state, audioPlaying) {
      state.audioPlaying = audioPlaying
    },

    setCurrentBox (state, currentBox) {
      state.currentBox = currentBox
    },

    setBoxStatus (state, boxStatus) {
      if (boxStatus != null) {
        boxStatus.song_queue.forEach(song => {
          song.minutesAndSeconds = secondsToMinAndSec(song.duration)
        })
      }
      state.boxStatus = boxStatus
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/audio.js